var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Updated Mar 10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1500,
    height: 945,
    transform: "translate(-1411 -449)",
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Complete page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 26887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 26888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page content"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 884,
    transform: "translate(-1271 -385)",
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Card",
    filter: "url(#filter0_d_8817_1659)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8817_1659)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251,
    y: -179,
    width: 1320,
    height: 667,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 26714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 26856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 28075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 28074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 28073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 28070"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -942,
    y: -78,
    width: 979,
    height: 115,
    rx: 7,
    fill: "#F8B369",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: -942,
    y: -78,
    width: 979,
    height: 115,
    rx: 7,
    stroke: "#F8B369",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 28070_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 26911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Business Buttons light Small - Icons only"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -10,
    width: 36,
    height: 36,
    rx: 8,
    fill: "#F2F2F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 27068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feather-icon 16px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 3.33398C8.36811 3.33398 8.66659 3.63246 8.66659 4.00065V7.72451L10.4713 9.52925C10.7317 9.7896 10.7317 10.2117 10.4713 10.4721C10.211 10.7324 9.78886 10.7324 9.52851 10.4721L7.52851 8.47205C7.40349 8.34703 7.33325 8.17746 7.33325 8.00065V4.00065C7.33325 3.63246 7.63173 3.33398 7.99992 3.33398Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 246",
    d: "M14.6751 8C15.0444 8 15.3469 8.29999 15.3133 8.66773C15.193 9.98534 14.7184 11.2505 13.9341 12.3263C13.018 13.5828 11.7268 14.5161 10.2463 14.9918C8.7659 15.4674 7.17269 15.4608 5.69621 14.973C4.21973 14.4852 2.93619 13.5413 2.0305 12.2774C1.12481 11.0134 0.643706 9.49451 0.656499 7.93958C0.669291 6.38466 1.17532 4.87393 2.10169 3.62501C3.02805 2.37609 4.32694 1.45345 5.81125 0.990005C7.0821 0.593204 8.4327 0.550553 9.71903 0.860272C10.078 0.946714 10.2648 1.32961 10.1461 1.67928C10.0274 2.02894 9.64804 2.21221 9.28736 2.13307C8.2711 1.91007 7.21024 1.95411 6.20981 2.26647C4.99578 2.64553 3.93341 3.40016 3.17572 4.42166C2.41804 5.44316 2.00416 6.6788 1.9937 7.95058C1.98323 9.22237 2.37673 10.4647 3.1175 11.4985C3.85828 12.5323 4.90809 13.3043 6.11571 13.7033C7.32334 14.1023 8.62644 14.1076 9.8373 13.7186C11.0482 13.3296 12.1043 12.5662 12.8536 11.5385C13.471 10.6916 13.8538 9.70126 13.9693 8.66727C14.0104 8.30028 14.3059 8 14.6751 8Z",
    fill: "#A793F6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5156 4.50781C10.5156 4.23167 10.7395 4.00781 11.0156 4.00781H15.0156C15.2918 4.00781 15.5156 4.23167 15.5156 4.50781C15.5156 4.78395 15.2918 5.00781 15.0156 5.00781H11.0156C10.7395 5.00781 10.5156 4.78395 10.5156 4.50781Z",
    fill: "#A793F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0156 2.00781C13.2918 2.00781 13.5156 2.23167 13.5156 2.50781L13.5156 6.50781C13.5156 6.78395 13.2918 7.00781 13.0156 7.00781C12.7395 7.00781 12.5156 6.78395 12.5156 6.50781L12.5156 2.50781C12.5156 2.23167 12.7395 2.00781 13.0156 2.00781Z",
    fill: "#A793F6"
  }))))))))))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8817_1659",
    x: -1271,
    y: -194,
    width: 1360,
    height: 707,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8817_1659"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8817_1659",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8817_1659"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251,
    y: -179,
    width: 1320,
    height: 667,
    rx: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.ee19aa60c9440a960bc00e0a74785821.svg";
export { ForwardRef as ReactComponent };